import { InputRef } from "antd";
import React, { useRef, useState } from "react";
import { useMutation } from "react-query";
import { useNavigate } from "react-router";
import styled from "styled-components";
import { StatusType } from "../../../../components/atoms/Explain/types";
import TextInputs from "../../../../components/atoms/Inputs/TextInputs";
import {
  MAX_WIDTH,
  MIN_MORNITOR_WIDTH,
} from "../../../../components/constants";
import PhoneInput from "../../../../components/molecures/PhoneInput";
import useModals from "../../../../hooks/useModals";
import useUsers from "../../../../hooks/useUsers";
import { PATH } from "../../../../routes/constants/path";

import { SignIn, SignInCrew } from "../../../../apis/Login/apis";
import {
  MESSAGE_INVALID_USER,
  NOT_APPROVED_USER,
} from "../../../../apis/Login/apis/constants";
import { SignInRequest } from "../../../../apis/Login/apis/types";
import Button from "../../../../components/atoms/Button";
import Label from "../../../../components/atoms/Label";
import { HttpError } from "../../../../network/types";
import { alertError } from "../../../../shared/utils";
import { theme } from "../../../../theme";
import {
  ID_NULL,
  ID_PLACEHOLDER,
  NOT_PASS_REVIEW_ID,
  PWD_PLACEHOLDER,
} from "../../constants";

interface LoginDataForm extends SignInRequest {
  code: string;
}

const LoginForm: React.FC = () => {
  const { signIn } = useUsers();
  const nav = useNavigate();

  const idRef = useRef<InputRef>(null);
  const pwdRef = useRef<InputRef>(null);
  const phoneRef = useRef<InputRef>(null);
  const { openConfirmModal, closeModal } = useModals();
  const signInMutation = useMutation(SignIn, {
    onSuccess: (res) => {
      const { admin, accessToken } = res;
      if (!accessToken) alertError("액세스 토큰이 없습니다.");
      else {
        signIn(admin, accessToken);

        nav(PATH.RESERVATION);
      }
    },
    onError: (err: HttpError) => {
      setAccessToken("");
      if (err.notTranslate === NOT_PASS_REVIEW_ID)
        nav(`${PATH.RE_REGISTER}?repairShopAId=${dataForm.repairShopAId}`);
      if (err.notTranslate === NOT_APPROVED_USER)
        nav(`${PATH.RE_REGISTER}?repairShopAId=${dataForm.repairShopAId}`);
      if (err.notTranslate === "NOT_FOUND_REPAIR_SHOP") {
        setAidStatus({ status: undefined, explain: undefined });
        setPassStatus({ status: undefined, explain: undefined });
        setDataForm({
          repairShopAId: "",
          pass: "",
          password: "",
          accessToken: "",
          authTokenId: "",
          repairShopPhone: "",
          code: "",
        });
        setStatus({
          phone: {
            status: undefined,
            explain: undefined,
          },
          auth: {
            status: undefined,
            explain: undefined,
          },
        });
        openConfirmModal({
          contents: (
            <div>
              등록되지 않은 회원정보입니다.
              <br /> 신청페이지로 이동합니다.
            </div>
          ),
          title: "등록 되지 않은 회원 정보",
          onOk: () => {
            nav(PATH.REGISTER);
            closeModal();
          },
        });
      } else if (err.message === MESSAGE_INVALID_USER) {
        setPassStatus({
          status: "error",
          explain: MESSAGE_INVALID_USER,
        });
      } else setAidStatus({ status: "error", explain: err.message });
    },
  });

  const signInCrewMutation = useMutation(SignInCrew, {
    onSuccess: (res) => {
      const { admin, accessToken } = res;
      if (!accessToken) alertError("액세스 토큰이 없습니다.");
      else {
        signIn(admin, accessToken);

        nav(PATH.RESERVATION);
      }
    },
    onError: (err: HttpError) => {
      setAccessToken("");
      if (err.notTranslate === NOT_PASS_REVIEW_ID)
        nav(`${PATH.RE_REGISTER}?repairShopAId=${dataForm.repairShopAId}`);
      if (err.notTranslate === NOT_APPROVED_USER)
        nav(`${PATH.RE_REGISTER}?repairShopAId=${dataForm.repairShopAId}`);
      if (err.notTranslate === "NOT_FOUND_REPAIR_SHOP") {
        setAidStatus({ status: undefined, explain: undefined });
        setPassStatus({ status: undefined, explain: undefined });
        setDataForm({
          repairShopAId: "",
          pass: "",
          password: "",
          accessToken: "",
          authTokenId: "",
          repairShopPhone: "",
          code: "",
        });
        openConfirmModal({
          contents: (
            <div>
              등록되지 않은 회원정보입니다.
              <br /> 신청페이지로 이동합니다.
            </div>
          ),
          title: "등록 되지 않은 회원 정보",
          onOk: () => {
            nav(PATH.REGISTER);
            closeModal();
          },
        });
      } else if (err.message === MESSAGE_INVALID_USER) {
        setPassStatus({
          status: "error",
          explain: MESSAGE_INVALID_USER,
        });
      } else setAidStatus({ status: "error", explain: err.message });
    },
  });

  const [dataForm, setDataForm] = useState<LoginDataForm>({
    repairShopAId: "",
    pass: "",
    password: "",

    authTokenId: "",
    repairShopPhone: "",
    code: "",
  });
  const [accessToken, setAccessToken] = useState<string>("");
  const [aIdStatus, setAidStatus] = useState<{
    status?: StatusType;
    explain?: string;
  }>({ status: undefined, explain: undefined });

  const [passStatus, setPassStatus] = useState<{
    status?: StatusType;
    explain?: string;
  }>({ status: undefined, explain: undefined });

  const [status, setStatus] = useState<{
    phone: { status?: StatusType; explain?: string };
    auth: { status?: StatusType; explain?: string };
  }>({
    phone: {
      status: undefined,
      explain: undefined,
    },
    auth: {
      status: undefined,
      explain: undefined,
    },
  });

  const onSiginIn = () => {
    if (checkNull() === true) {
      signInMutation.mutate({
        repairShopAId: dataForm.repairShopAId,
        password: dataForm.pass || "",
        repairShopPhone: dataForm.repairShopPhone,
        authTokenId: dataForm.authTokenId,
        accessToken,
      });
    }
  };

  const onSignInCrew = () => {
    if (checkNull() === true) {
      signInCrewMutation.mutate({
        repairShopAId: dataForm.repairShopAId,
        password: dataForm.pass,
      });
    }
  };

  const onNavToRegister = () => {
    const values = Object.values(dataForm);

    let isNull = false;
    for (let i = 0; i < values.length; i += 1) {
      if (values[i] !== "") {
        isNull = true;
        break;
      }
    }
    if (isNull)
      return openConfirmModal({
        contents: "작성하신 내용이 저장되지 않습니다.",
        title: "작성내용 취소",
        onOk: () => {
          closeModal();
          nav(PATH.REGISTER);
        },
      });
    closeModal();
    return nav(PATH.REGISTER);
  };
  const checkNull = () => {
    if (dataForm.repairShopAId === "") {
      setAidStatus({ status: "error", explain: ID_NULL });
    }
    if (dataForm.pass === "") {
      setPassStatus({ status: "error", explain: PWD_PLACEHOLDER });
    }

    if (dataForm.repairShopAId === "") {
      idRef.current?.focus();

      return false;
    }
    if (dataForm.pass === "") {
      pwdRef.current?.focus();

      return false;
    }

    return true;
  };

  return (
    <FormContatiner>
      <FormWrapper>
        <FormTitle>Log In</FormTitle>
        <Wrapper>
          <Label isRequired>아이디</Label>
          <TextInputs
            ref={idRef}
            status={aIdStatus.status}
            explain={aIdStatus.explain}
            isNotBordered
            name="username"
            value={dataForm.repairShopAId}
            autoComplete="on"
            onChange={(e) => {
              setDataForm({ ...dataForm, repairShopAId: e, accessToken: "" });
              setAccessToken("");
              setAidStatus({ status: undefined, explain: undefined });
              setPassStatus({ status: undefined, explain: undefined });
            }}
            placeholder={ID_PLACEHOLDER}
          />
        </Wrapper>
        <Wrapper>
          <Label isRequired>비밀번호</Label>
          <TextInputs
            ref={pwdRef}
            status={passStatus.status}
            explain={passStatus.explain}
            isNotBordered
            isPassword
            name="current-password"
            value={dataForm.pass}
            autoComplete="on"
            onChange={(e) => {
              setDataForm({ ...dataForm, pass: e, accessToken: "" });
              setAccessToken("");
              setAidStatus({ status: undefined, explain: undefined });
              setPassStatus({ status: undefined, explain: undefined });
            }}
            placeholder={PWD_PLACEHOLDER}
          />
        </Wrapper>
        <BtnWrapper>
          <Button
            style={{
              width: "100%",
              height: "56px",
              fontWeight: 400,
              fontSize: "20px",
              lineHeight: "24px",
            }}
            onClick={onSignInCrew}
          >
            로그인
          </Button>
        </BtnWrapper>
        <NavWrapper>
          <TextBtn
            onClick={() => {
              nav("/pwd_reset");
            }}
          >
            비밀번호 재설정
          </TextBtn>
          <StyledBar>|</StyledBar>
          <TextBtn isMain onClick={onNavToRegister}>
            제휴 신청하기
          </TextBtn>
        </NavWrapper>
      </FormWrapper>
    </FormContatiner>
  );
};
export default LoginForm;

const TextBtn = styled.div<{ isMain?: boolean }>`
  color: ${({ isMain }) =>
    !isMain ? theme.colors.gray3 : theme.colors.mainPrimary3};
  cursor: pointer;
  ${theme.typo.heading.b14};
`;
const FormContatiner = styled.div`
  flex: 1 1 0;
  display: flex;
  justify-content: center;
  align-content: center;
  overflow: hidden;
  overflow-y: auto;
`;
const FormWrapper = styled.form`
  min-width: ${MAX_WIDTH};
  max-width: ${MAX_WIDTH};
  display: flex;
  justify-content: center;
  flex-direction: column;
  /* min-height: 1000px; */
  @media only screen and (max-width: ${MIN_MORNITOR_WIDTH}) {
    max-width: 100vw;
    min-width: 90vw;
  }
`;
const Wrapper = styled.div`
  margin-bottom: 60px;
`;
const StyledBar = styled.div`
  margin: 0px 16px;
  color: #d2d2d2;
  line-height: 24px;
  font-size: 16px;
`;
const BtnWrapper = styled.div`
  width: 100%;
  height: 56px;
`;
const FormTitle = styled.span`
  ${theme.typo.title.t32};
  margin-bottom: 60px;
`;

const NavWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  height: 24px;
  margin-top: 16px;
  align-items: center;
  align-content: center;
  ${theme.typo.body.r14}
  font-size:14px;
`;
